/**
 * Adobe / Figma-style selection handles for canvas elements. 8 white square edge nodes
 * (top-left, top, top-right, right, bottom-right, bottom, bottom-left, left) + 4 round
 * corner rotation pucks. Pure CSS — no logic, just visual overlay rendered when an
 * element is selected.
 */
export default function SelectionHandles() {
  const square = {
    position: "absolute",
    width: 10,
    height: 10,
    borderRadius: 2,
    background: "#ffffff",
    border: "2px solid #0db7ff",
    boxShadow: "0 8px 20px rgba(0,0,0,0.24)",
    pointerEvents: "none",
    zIndex: 30,
  };
  const corner = {
    position: "absolute",
    width: 14,
    height: 14,
    borderRadius: 999,
    background: "radial-gradient(circle, #ffffff 0 32%, #0db7ff 34% 55%, #ffffff 57%)",
    border: "1px solid #0db7ff",
    pointerEvents: "none",
    zIndex: 31,
  };
  return (
    <>
      {/* Edge midpoint handles */}
      <span data-testid="md-handle-tm" style={{ ...square, top: -7, left: "calc(50% - 5px)" }} />
      <span data-testid="md-handle-rm" style={{ ...square, right: -7, top: "calc(50% - 5px)" }} />
      <span data-testid="md-handle-bm" style={{ ...square, bottom: -7, left: "calc(50% - 5px)" }} />
      <span data-testid="md-handle-lm" style={{ ...square, left: -7, top: "calc(50% - 5px)" }} />

      {/* Corner squares */}
      <span data-testid="md-handle-tl" style={{ ...square, top: -7, left: -7 }} />
      <span data-testid="md-handle-tr" style={{ ...square, top: -7, right: -7 }} />
      <span data-testid="md-handle-br" style={{ ...square, bottom: -7, right: -7 }} />
      <span data-testid="md-handle-bl" style={{ ...square, bottom: -7, left: -7 }} />

      {/* Round corner-rotation pucks (slightly inset) */}
      <span data-testid="md-handle-rotate-tl" style={{ ...corner, top: 14, left: 14 }} />
      <span data-testid="md-handle-rotate-tr" style={{ ...corner, top: 14, right: 14 }} />
      <span data-testid="md-handle-rotate-br" style={{ ...corner, bottom: 14, right: 14 }} />
      <span data-testid="md-handle-rotate-bl" style={{ ...corner, bottom: 14, left: 14 }} />
    </>
  );
}
